import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/UI/Button';
export const SalonSpotlight = () => {
  const spotlightFeatures = [{
    id: 'dr-osagie-alex',
    name: 'Dr. Osagie Alex',
    title: 'The Discipline of Becoming More',
    coverImage: 'https://cdn.magicpatterns.com/uploads/4PLoghNtqGw9RzWLL9Eoee/1.png',
    excerpt: 'Some people speak about growth. Others build a life around it. Dr. Osagie Alex belongs firmly in the second category. An Upgrade Mastery Practitioner and founder of TWCC Resources.',
    date: 'February 2025'
  }, {
    id: 'augustine-aigbokhaevbo',
    name: 'Augustine Aigbokhaevbo',
    title: 'The Voice That Holds the Room—and the Moment',
    coverImage: 'https://cdn.magicpatterns.com/uploads/9umWqNKiHbUDpxfJtwUhB7/2.png',
    excerpt: "Some people don't just speak into microphones. They hold space. They read the room, feel the tension, sense the silence, and guide moments with intention. Augustine Aigbokhaevbo is one of those people.",
    date: 'February 2025'
  }, {
    id: 'bibi-eneje',
    name: 'Bibi Eneje',
    title: 'Architect of Influence. Builder of Ecosystems. Champion of Clarity.',
    coverImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iAnbjCZ3t34HT1XWLnohD6/Bibi_Eneje_The_Networking_Salon_Spotlight.png',
    excerpt: "Every community has people whose presence doesn't just add energy—they elevate the room. In The Networking Salon, Bibi Eneje is one of those rare catalysts.",
    date: 'January 2025'
  }];
  return <div className="pt-20 bg-white min-h-screen" data-id="element-3889">
      <section className="relative py-16 bg-gray-50 border-b border-gray-200" data-id="element-3890">
        <div className="container mx-auto px-4" data-id="element-3891">
          <div className="max-w-4xl mx-auto text-center" data-id="element-3892">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" data-id="element-3893">
              ✨ The Salon Spotlight
            </h1>
            <p className="text-xl text-gray-600 mb-4" data-id="element-3894">
              Celebrating remarkable people shaping culture in their own unique
              ways — creators, thinkers, innovators, builders, and dreamers who
              are pushing boundaries and making impact.
            </p>
            <p className="text-lg text-gray-600" data-id="element-3895">
              This feature is part of The Networking Salon's ongoing effort to
              celebrate individuals who are moving ideas, communities, and
              culture forward.
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-3896">
        <div className="container mx-auto px-4" data-id="element-3897">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-3898">
            {spotlightFeatures.map(feature => <Link key={feature.id} to={`/spotlight/${feature.id}`} className="border-2 border-gray-300 rounded-lg overflow-hidden hover:border-gray-500 transition-colors" data-id="element-3899">
                <div className="aspect-[4/3] overflow-hidden bg-gray-100" data-id="element-3900">
                  <img src={feature.coverImage} alt={feature.name} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all" data-id="element-3901" />
                </div>
                <div className="p-6" data-id="element-3902">
                  <p className="text-sm text-gray-500 mb-2" data-id="element-3903">{feature.date}</p>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-3904">
                    {feature.name}
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-3905">{feature.title}</p>
                  <p className="text-gray-600 line-clamp-3" data-id="element-3906">
                    {feature.excerpt}
                  </p>
                  <div className="mt-4" data-id="element-3907">
                    <span className="text-gray-700 font-medium hover:underline" data-id="element-3908">
                      Read Full Story →
                    </span>
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </section>
    </div>;
};